/*
  즉시 복사 흐름의 문구.

  아직 번역 시트에 없어 한국어로 하드코딩해 둔다 — 같은 브랜치의 `FOLDER_COPY` 와 같은 이유이고,
  시트 등록 때 키로 한 번에 옮긴다.

  ⚠️ **`copied`·`blocked*` 은 회귀다.** 원래 번역이 있는 문구인데(각각
  `build:build.toast.duplicated`·`build:build.studentCopyBlocked.*`, 전 로케일 번역됨) 그 키를
  쓰려면 `build` 네임스페이스(ko 기준 59KB)를 플레이 페이지에 얹어야 한다 — 문구 네 개 때문에
  치르기엔 큰 값이라 시트 등록 배치까지 한국어로 둔다. **그때까지 비한국어 사용자는 한국어를 본다.**

  실패 문구는 하드코딩하지 않는다 — `common:quizDetail.copy.failed` 가 이미 번역돼 있고
  `common` 은 모든 페이지가 로드하므로 그대로 쓴다.
*/
export const QUIZ_COPY_TEXT = {
  copied: '내 퀴즈로 복사했어요',

  /** 인증 왕복을 거쳐 돌아온 사람에게 띄우는 결과 모달. 토스트로는 놓친다. */
  copiedTitle: '내 퀴즈로 복사했어요',
  copiedDescription: '이제 자유롭게 수정하고 수업에 활용할 수 있어요.',
  viewCopied: '퀴즈 보러 가기',
  keepPlaying: '계속 풀기',

  /*
    학생 계정 차단. 문구는 기존 차단 안내(`useStudentCopyBlockedNotice`, `build.studentCopyBlocked.*`)
    와 같은 말이고 모달용이라 줄바꿈 마크업만 뺐다. 원탭이 살아 있으면 그 화면 대신 이 모달이
    같은 자리에서 알린다 — 인라인 흐름은 그 페이지를 거치지 않으므로 안내가 사라지면 학생은
    "아무 일도 안 일어났다"로 느낀다.
  */
  blockedTitle: '학생 계정에서는 이 퀴즈를 복사할 수 없어요',
  blockedDescription:
    '원활한 퀴즈 참여를 위해 학생 계정에서는 일부 퀴즈의 복사를 제한하고 있어요. 다른 계정으로 로그인한 뒤 다시 시도해 주세요.',

  /*
    인증 탭의 마지막 화면. 결과는 원탭이 알리므로 여기서는 "돌아가라"만 말한다 — 탭이 말없이
    닫히면 사용자는 무슨 일이 일어났는지 모른 채 화면이 바뀐다.
  */
  returnTitle: '로그인했어요',
  returnDescription:
    '퀴즈를 보던 탭으로 돌아가 주세요.\n복사 결과는 그 탭에서 확인할 수 있어요.',
  returnAction: '기존 탭으로 돌아가기',
} as const;
